/**
 * Orders
 */

// React
import React, { useEffect, useState, useContext } from "react";
import useQuery from "../../utils/hook/useQuery";
import MessageRepository from "client-sdk/src/Repository/message-repository";
// Context

// UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  DialogTitle,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
// Icon
import Icon from "@mdi/react";
import { mdiClose, mdiPlus, mdiMinusCircleOutline } from "@mdi/js";
import GeneralList from "./generalList";
import PrivatelList from "./privateList";
// Components
import Pagination from "@material-ui/lab/Pagination";
import { convertPersianDigit2English } from "../../utils/helpers";

// Helper
import { checkMatchMedia } from "../../utils/helpers";

// Type
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotfication";
import moment from "moment";
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // '@media (max-width: 480px)': {
      //   marginLeft: '75px',
      // },
      backgroundColor: "#fff",
      marginTop: "24px",
      padding: "24px",
      borderRadius: "4px",
    },
    loading: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    cards: {
      position: "relative",
      backgroundColor: "white",
      padding: "14px",
      transition: "all .3s",
      "&:hover": {
        transform: "scale(1.05)",
        // transform: "scaleY(1.05)",
        transition: "all .3s",
      },
    },
    boxshadow: {
      position: "relative",
      backgroundColor: "white",
      padding: "14px",
      transform: "scale(1.05)",
      border: "1px solid #3449B0",
      height: "100%",
    },
    iconHeader: {
      position: "absolute",
      top: "5px",
      right: "5px",
    },
    cardContent: {
      marginTop: "-22px",
      display: "flex",
    },
    typographyCards: {
      fontSize: "20px",
      fontWeight: "bold",
      color: "#383836",
      marginBottom: "24px",
      marginTop: "72px",
      // padding: '8px 24px 8px 50px',
      // marginLeft: '-40px',
    },
    textArea: {
      width: "100%",
    },
    cancelTitle: {
      marginTop: "45px",

      fontSize: "16px",
      fontWeight: 500,
      textAlign: "center",
      marginBottom: theme.spacing(1),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      marginTop: "5px",
      padding: "24px 0",
      display: "flex",
      flexDirection: "row-reverse",
      // width: '100%',
      "@media (max-width: 480px)": {
        display: "none",
        flexDirection: "column-reverse",
        width: "100%",
      },
    },
    titleBar: {
      padding: "5px 2px",
      width: "100%",
      borderRadius: "0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "@media (max-width: 480px)": {
        width: "100%",
        marginLeft: "-70px",

        marginTop: "55px",
        flexDirection: "column",
        alignItem: "center",
        fontSize: "12px",
      },
    },
    headerBox: {
      marginLeft: "75px",
      display: "flex",
      alignItems: "center",
      marginBottom: "10px",
      marginTop: "10px",
      "@media (max-width: 480px)": {
        marginLeft: "-5px",

        fontSize: "12px",
      },
    },
    mobile: {
      maxWidth: "120%",
      margin: "24px 0",
      "@media (max-width: 480px)": {
        marginTop: "140px",
      },
    },
    tabContainer: {
      display: "flex",
      borderBottom: "1px solid #e9eaf3",
      listStyle: "none",
      columnGap: "40px",
      padding: 0,
    },
    tabItems: {
      fontSize: "16px",
      fontWeight: 600,
      cursor: "pointer",
      padding: "5px",
    },
    active: {
      color: "#4C599E",
      borderBottom: "3px solid #4C599E",
    },
  })
);
const Messages = (props: any) => {
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  },"created,desc");
  const [tab, setTab] = useState(1);
  const [privateMessages, setPrivateMessages] = useState([]);
  const [generalMessages, setGeneralMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const [privateMessagesLoading, setPrivateMessagesLoading] = useState(false);
  const [generalMessagesLoading, setGeneralMessagesLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const [privateMessagesCount, setPrivateMessagesCount] = useState(0);
  const [generalMessagesCount, setGeneralMessagesCount] = useState(0);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [messageExpireTime, setMessageExpireTime] = useState(null);
  const [modalUsers, setModalUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState({});
  const [titleValue, setTitleValue] = useState("");
  const [messageValue, setMessageValue] = useState("");
  const [modal, setModal] = useState("");
  const [selectedMessage, setSelectedMessage] = useState("")

  const classes = useStyles();

  /////////////////////////////////
  //request
  const getUsers = async () => {
    const { page, size } = filtersValues;
    try {
      setUsersLoading(true);
      const response = await MessageRepository.getAllUsers({
        payload: {
          ...filtersValues,
          page,
          size,
        },
      });
      setUsersLoading(false);
      setUsers(response.data);
    } catch (error) {
      handleError(error);
    }
  };
  const getPrivateMessages = async () => {
    console.log({
      ...filtersValues
    })
    const { page, size } = filtersValues;
    try {
      setPrivateMessagesLoading(true);
      const response = await MessageRepository.getAllPrivateMessages({
        payload: {
          ...filtersValues,
          page,
          size,
          sort: "created,desc"
        },
      });
      setPrivateMessagesLoading(false);
      setPrivateMessages(response.data);
      setPrivateMessagesCount(parseInt(response.headers["x-total-count"]));
    } catch (error) {
      handleError(error);
    }
  };
  const getGeneralMessages = async () => {
    const { page, size } = filtersValues;
    try {
      setGeneralMessagesLoading(true);
      const response = await MessageRepository.getAllGeneralMessages({
        payload: {
          ...filtersValues,
          page,
          size,
          sort: "created,desc"
        },
      });
      setGeneralMessagesLoading(false);
      setGeneralMessages(response.data);
      setGeneralMessagesCount(parseInt(response.headers["x-total-count"]));
    } catch (error) {
      handleError(error);
    }
  };

  const cancelEverithing = () => {
    setTitleValue("");
    setMessageValue("");
    setMessageExpireTime(null);
    setSelectedUsers({});
  };

  const addPrivateMessage = async () => {
    try {
      const callback = await MessageRepository.addPrivateMessage({
        payload: {
          body: {
            title: titleValue,
            message: messageValue,
            messageType: "GENERAL_PRIVATE",
            objectId: null,
            destinationUserId: parseInt(Object.keys(selectedUsers)[0]),
          },
          callback: () => getPrivateMessages(),
        },
      });
      callback();
      cancelEverithing();
    } catch (error) {
      handleError(error);
    }
  };

  const addGeneralMessage = async () => {
    const gmtTime = convertPersianDigit2English(moment(messageExpireTime).subtract(3,"hours").subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss"))
    const timeArray = gmtTime.split(" ");
    const time = timeArray[0] + "T" + timeArray[1] + "Z";
    try {
      const callback = await MessageRepository.addGeneralMessage({
        payload: {
          body: {
            title: titleValue,
            message: messageValue,
            expiredTime: time,
          },
          callback: () => getGeneralMessages(),
        },
      });
      callback();
      cancelEverithing();
    } catch (error) {
      handleError(error);
    }
  };

  const addMultiPrivateMessages = async () => {
    try {
      const callback = await MessageRepository.addMultiPrivateMessage({
        payload: {
          body: {
            title: titleValue,
            message: messageValue,
            messageType: "GENERAL_PRIVATE",
            objectId: null,
            destinationUserIds: Object.keys(selectedUsers),
          },
          callback: () => getPrivateMessages(),
        },
      });
      callback();
      cancelEverithing();
    } catch (error) {
      handleError(error);
    }
  };
  const messageInvisibleHandler = async (id) => {
    try {
      const { pagination, callback } = await MessageRepository.invisibleMessage(
        {
          payload: {
            id,
            pagination: filtersValues,
            callback: () => getGeneralMessages(),
          },
        }
      );
      callback();
    } catch (error) {
      handleError(error);
    }
  };

  //effects
  useEffect(() => {
    // getUsers();
    if (tab == 1) {
      getGeneralMessages();
    } else {
      getPrivateMessages();
      getUsers();
    }
  }, [filtersValues, tab]);
  ////////////////////////////////

  // handlers
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleClose = () => {
    setOpenSize(false);
    setIsModalOpen(false);
    setIsUserModalOpen(false);
    cancelEverithing();
  };
  const handleUserModalClose = () => {
    setIsUserModalOpen(false);
  };
  const handlePartnerSearch = (e) => {
    // if (timeOut) {
    //   clearTimeout(timeOut);
    // }
    const filteredUsers = users.filter((user) => {
      return user.ronadUserName.includes(e.target.value);
    });
    setModalUsers(filteredUsers);
    // timeOut = setTimeout(() => {
    //   setModalUsers(filteredUsers);
    // }, 2000);
  };
  const handleUserCheck = (e, modalUser) => {
    const userName = e.target.name;
    if (e.target.checked) {
      setSelectedUsers({ ...selectedUsers, [userName]: modalUser });
    } else {
      const { [userName]: removedUser, ...entireUsers } = selectedUsers;
      setSelectedUsers(entireUsers);
    }
  };
  const handleRemoveUser = (id) => {
    const { [id]: removedUser, ...entireUsers } = selectedUsers;
    setSelectedUsers(entireUsers);
  };
  const handleSendMessage = () => {
    if (tab == 1) {
      addGeneralMessage();
    } else if (Object.values(selectedUsers).length > 1) {
      addMultiPrivateMessages();
    } else {
      addPrivateMessage();
    }
    handleClose();
  };
  const handleChangeSizePage = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleMessageExpireTime = (date: any) => {
    setMessageExpireTime(
      convertPersianDigit2English(date.format("YYYY-MM-DD HH:mm:ss"))
    );
  };
  const removeMessage = async () => {
    try {
      await MessageRepository.deleteMessageAdmin({
        payload: {id: selectedMessage}
      })
      getPrivateMessages()
      handleNotfication("پیام با موفقیت از پنل پارتنر حذف شد." , "success")
      setModal("")
    } catch (error) {
      handleError(error)
    }
  }
  const openConfirmModal = (id: string) => {
    setSelectedMessage(id)
    setModal("CONFIRM")
  }
  return (
    <>
      <Typography variant="h6" component="h1">
        {"آخرین پیام ها"}
      </Typography>
      <div className={classes.root}>
        <div style={{ marginTop: "20px" }}>
          <div className={classes.btnBox}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsModalOpen(true)}
              size={checkMatchMedia("(max-width: 1024px)") ? "small" : "large"}
            >{`ایجاد پیام جدید`}</Button>
          </div>
          <ul className={classes.tabContainer}>
            <li
              onClick={() => setTab(1)}
              className={classes.tabItems + " " + (tab == 1 && classes.active)}
            >
              پیام‌های‌عمومی
            </li>
            <li
              onClick={() => {
                setTab(2);
              }}
              className={classes.tabItems + " " + (tab == 2 && classes.active)}
            >
              پیام‌های‌خصوصی
            </li>
          </ul>
          {tab == 1 && (
            <>
              <Grid container>
                <Grid container item xs={12} md={12} lg={12}>
                  {generalMessagesLoading ? (
                    <div className={classes.loading}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {generalMessages?.length > 0 ? (
                        <GeneralList
                          data={generalMessages}
                          messageInvisibleHandler={messageInvisibleHandler}
                        />
                      ) : (
                        <Typography variant="h3" component="div">
                          پیامی موجود نیست
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ padding: "20px 10px 0 10px" }}
                >
                  {generalMessages.length > 0 && (
                    <FormControl
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ marginLeft: "10px", color: "#8a8a8a" }}>
                        {" "}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleClose}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  container
                  item
                  direction="row-reverse"
                  style={{ padding: "20px 10px 0 10px" }}
                >
                  {generalMessages.length > 0 && (
                    <Pagination
                      className={classes.pagination}
                      count={Math.ceil(
                        generalMessagesCount / filtersValues.size
                      )}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  )}
                </Grid>
              </Grid>
            </>
          )}
          {tab == 2 && (
            <>
              <Grid container>
                <Grid container item xs={12} md={12} lg={12}>
                  {privateMessagesLoading ? (
                    <div className={classes.loading}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {privateMessages?.length > 0 ? (
                        <PrivatelList data={privateMessages} openConfirm={openConfirmModal}/>
                      ) : (
                        <Typography variant="h3" component="div">
                          پیامی موجود نیست
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ padding: "20px 10px 0 10px" }}
                >
                  {privateMessages.length > 0 && (
                    <FormControl
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ marginLeft: "10px", color: "#8a8a8a" }}>
                        {" "}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleClose}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  container
                  item
                  direction="row-reverse"
                  style={{ padding: "20px 10px 0 10px" }}
                >
                  {privateMessages.length > 0 && (
                    <Pagination
                      className={classes.pagination}
                      count={Math.ceil(
                        privateMessagesCount / filtersValues.size
                      )}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  )}
                </Grid>
              </Grid>
            </>
          )}
        </div>
        <Dialog
          open={isModalOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
          fullWidth
        >
          <DialogContent>
            <div
              style={{
                position: "absolute",
                left: "3px",
                top: "10px",
                zIndex: 10,
              }}
            >
              {handleClose ? (
                <IconButton aria-label="close" onClick={handleClose}>
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              ) : null}
            </div>

            <div className={classes.cancelTitle}>{"ایجاد پیام جدید"}</div>
            {tab == 2 && (
              <Button
                onClick={() => {
                  setIsUserModalOpen(true);
                }}
                style={{ border: "solid 1px #000000", justifyContent: "right" }}
                fullWidth
                startIcon={<Icon path={mdiPlus} size={1} />}
              >
                {"انتخاب پارتنر"}
              </Button>
            )}
            <Grid xs={12} container style={{ marginTop: "10px" }}>
              {Object.values(selectedUsers).map((selectedUser, index) => {
                return (
                  <>
                    <Grid container spacing={0.5} item xs={3}>
                      <Grid
                        item
                        xs={1}
                        style={{
                          marginTop: "2px",
                          marginLeft: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleRemoveUser(selectedUser.id)}
                      >
                        <Icon
                          path={mdiMinusCircleOutline}
                          size={0.5}
                          color="red"
                        />
                      </Grid>
                      <Grid item xs={9}>
                        {selectedUser.ronadUserName}
                      </Grid>
                    </Grid>
                  </>
                );
              })}
            </Grid>
            <Grid
              container
              spacing={tab == 1 && 2}
              xs={12}
              style={{ marginTop: "16px" }}
            >
              <Grid item xs={tab == 2 ? 12 : 8}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="title"
                  label="عنوان پیام"
                  name="title"
                  autoFocus
                  onChange={(e) => {
                    setTitleValue(e.target.value);
                  }}
                />
              </Grid>
              {tab == 1 && (
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DateTimePicker
                      inputVariant="outlined"
                      id="expireTime"
                      name="expireTime"
                      label="* تاریخ انقضای پیام"
                      format="YYYY/MM/DD HH:mm:ss"
                      labelFunc={date =>
                        date?.isValid()
                          ? date.format('jYYYY/jMM/jDD HH:mm')
                          : ''
                      }
                      fullWidth
                      disablePast
                      autoOk
                      okLabel={null}
                      cancelLabel={null}
                      value={messageExpireTime ? messageExpireTime : null}
                      onChange={handleMessageExpireTime}
                      style={{ marginTop: "15px" }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              )}
            </Grid>
            <Grid xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="message"
                label="متن پیام..."
                name="message"
                autoFocus
                inputProps={{
                  style: {
                    height: "150px",
                  },
                }}
                multiline
                size="medium"
                onChange={(e) => {
                  setMessageValue(e.target.value);
                }}
              />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              style={{ textAlign: "center", marginBottom: "8px" }}
            >
              <Grid item xs={12}>
                <Button
                  style={{ marginLeft: "8px" }}
                  autoFocus
                  onClick={handleClose}
                  variant="outlined"
                  color="primary"
                  size="large"
                  data-cy="closeCancelation"
                >
                  {`انصراف
`}
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  data-cy="submitCancelation"
                  color="primary"
                  onClick={handleSendMessage}
                >
                  {"ارسال"}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          open={isUserModalOpen}
          onClose={handleUserModalClose}
          aria-labelledby="responsive-dialog-title"
          fullWidth
        >
          <DialogContent>
            <div
              style={{
                position: "absolute",
                left: "3px",
                top: "10px",
                zIndex: 10,
              }}
            >
              {handleUserModalClose ? (
                <IconButton aria-label="close" onClick={handleUserModalClose}>
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              ) : null}
            </div>

            <Grid xs={12} style={{ marginTop: "15px" }}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="partnerSearch"
                label="جست و جوی پارتنر"
                name="partnerSearch"
                autoFocus
                onChange={handlePartnerSearch}
              />
            </Grid>
            <Grid
              xs={12}
              style={{
                maxHeight: "250px",
                overflow: "auto",
                direction: "ltr",
                margin: "10px 0",
              }}
            >
              {modalUsers[0]
                ? modalUsers.map((modalUser, index) => {
                    return (
                      <Grid
                        key={index}
                        xs={12}
                        container
                        style={{ direction: "rtl" }}
                      >
                        <Grid xs={1} item>
                          <Checkbox
                            checked={selectedUsers[modalUser.id]}
                            onChange={(e) => handleUserCheck(e, modalUser)}
                            name={modalUser.id}
                          />
                        </Grid>
                        <Grid xs={11} item>
                          <span
                            style={{
                              display: "inline-block",
                              marginTop: "10px",
                            }}
                          >
                            {modalUser.ronadUserName}
                          </span>
                        </Grid>
                      </Grid>
                    );
                  })
                : users.map((modalUser, index) => {
                    return (
                      <Grid
                        key={index}
                        xs={12}
                        container
                        style={{ direction: "rtl" }}
                      >
                        <Grid xs={1} item>
                          <Checkbox
                            checked={selectedUsers[modalUser.id]}
                            onChange={(e) => handleUserCheck(e, modalUser)}
                            name={modalUser.id}
                          />
                        </Grid>
                        <Grid xs={11} item>
                          <span
                            style={{
                              display: "inline-block",
                              marginTop: "10px",
                            }}
                          >
                            {modalUser.ronadUserName}
                          </span>
                        </Grid>
                      </Grid>
                    );
                  })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              style={{ textAlign: "center", marginBottom: "8px" }}
            >
              <Grid item xs={12}>
                <Button
                  style={{ marginLeft: "8px" }}
                  autoFocus
                  onClick={handleUserModalClose}
                  variant="outlined"
                  color="default"
                  size="large"
                  data-cy="closeCancelation"
                >
                  {`انصراف
`}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleUserModalClose}
                  size="large"
                  data-cy="submitCancelation"
                  color="primary"
                >
                  {"تایید"}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth
          open={modal === "CONFIRM"}
          onClose={() => setModal("")}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle>
            آیا از حذف پیام اطمینان دارید؟
          </DialogTitle>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => setModal("")}
              variant="contained"
              color="primary"
            >
              {`خیر`}
            </Button>
            
            <Button
              onClick={removeMessage}
              variant="outlined"
              color="primary"
            >
              {`بله`}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};
export default Messages;
